import moment from 'moment';
import getEnv from 'config/getEnv';

const INTERNAL_EMAIL_DOMAIN = '@spedy.com.br';
const BANNER_DISMISSED_KEY_PREFIX = 'spedy:assistant-banner:dismissed:';

export const isInternalUser = (email) =>
  !!email &&
  email
    .trim()
    .toLowerCase()
    .endsWith(INTERNAL_EMAIL_DOMAIN);

export const getLaunchDate = (value = getEnv('REACT_APP_MCP_LAUNCH_DATE')) => {
  if (!value) {
    return null;
  }

  const date = moment(value, moment.ISO_8601, true);
  return date.isValid() ? date : null;
};

export const isAssistantLaunched = ({
  email,
  launchDate = getLaunchDate(),
  now = moment()
} = {}) => {
  if (isInternalUser(email)) {
    return true;
  }

  return !!launchDate && !now.isBefore(launchDate);
};

export const getMcpUrl = () => {
  const value = getEnv('REACT_APP_MCP_URL');
  return /^https?:\/\/[^\s$]+$/.test(value || '') ? value : null;
};

const getBannerDismissedKey = (userId) =>
  `${BANNER_DISMISSED_KEY_PREFIX}${userId}`;

export const isBannerDismissed = (userId) => {
  try {
    return localStorage.getItem(getBannerDismissedKey(userId)) === '1';
  } catch {
    return false;
  }
};

export const dismissBanner = (userId) => {
  try {
    localStorage.setItem(getBannerDismissedKey(userId), '1');
  } catch {
    return;
  }
};
